module.exports = __webpack_public_path__ + "static/media/as.805863e4.svg";